'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import QHSETrafficLightSummary from './QHSETrafficLightSummary';
import QHSEItemsList from './QHSEItemsList';

const SITES = ['All Sites', 'Site Alpha', 'Site Beta', 'Warehouse B', 'Site Gamma'];

export default function QHSEDashboard() {
  const [selectedSite, setSelectedSite] = useState('All Sites');

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-teal-700 to-teal-900 rounded-2xl text-white">
        <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
          <Icon name="ShieldCheckIcon" size={22} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-700 text-base">QHSE Compliance Dashboard</p>
          <p className="text-[12px] text-white/65">Health, Safety &amp; Environment · Expiry &amp; Inspection Tracking</p>
        </div>
        {/* Site Filter */}
        <div className="flex items-center gap-2 shrink-0">
          <Icon name="FunnelIcon" size={14} className="text-white/60" />
          <select
            value={selectedSite}
            onChange={(e) => setSelectedSite(e?.target?.value)}
            className="bg-white/15 border border-white/20 text-white text-[12px] font-600 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-white/30 cursor-pointer"
          >
            {SITES?.map((s) => (
              <option key={s} value={s} className="bg-[#0D2240] text-white">{s}</option>
            ))}
          </select>
        </div>
      </div>
      {/* Traffic-light summary */}
      <QHSETrafficLightSummary selectedSite={selectedSite} />
      {/* Urgency-sorted items list with inline inspection history */}
      <QHSEItemsList selectedSite={selectedSite} />
    </div>
  );
}
